var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subjects',{attrs:{"config":_vm.config,"showPartnerCreateBtn":this.$root.userAllowedTo('create_user_credentials')},on:{"onUpdate":_vm.onUpdate,"onReprove":_vm.onReprove}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ee20b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AdminPartnersSubjects.vue
// module id = null
// module chunks = 